// Vendors
// import $ from 'jquery';
import UIkit from 'uikit';  // eslint-disable-line
import 'picturefill';
import 'lazysizes';
import 'nodelist-foreach-polyfill';
// import Turbolinks from 'turbolinks';

// import Modernizr from '../../node_modules/modernizr/modernizr'; // eslint-disable-line

import './navigation';
import './skip-link-focus-fix';
import '../editor/frontend.js';

import XDCarousel from '../editor/blocks/standard_carousel/frontend';
import XDSlider from '../editor/blocks/standard_slider/frontend';
import XDMediaGrid from '../editor/blocks/standard_media_grid/frontend';

// import './_homepage-hero';
// window.jQuery = $;

// Make UIkit available to child theme.
window.UIkit = UIkit;



/*
const data_nav_submenu_items = document.querySelectorAll('[data-submenu-id]');
console.log(data_nav_submenu_items);

if ( typeof data_nav_submenu_items !== 'undefined') {
  console.log('not undefined');
  data_nav_submenu_items.forEach((el) => {
    console.log(el);
    el.addEventListener('click', (e) => {
      e.preventDefault();
      
      console.log('click');
      
      const switcher_index = el.getAttribute('data-submenu-id');
      
      var notifications = UIkit.notification('MyMessage', 'danger');
      
      var nav_switcher = (switcher_index) => {
        UIkit.switcher('#sidebar_nav_menu').show(switcher_index);
      };
      
      nav_switcher(switcher_index);
    });
  }); 
}
*/


const updateLeapMenu = () => {
  setTimeout(() => {
    document.querySelector('.xdf-modal-menu__body .container').style.height = 
      document.querySelector('.xdf-leap-menu ul.active').offsetHeight + 150 + 'px';
  }, 100);
};

const bindEvent = (el, eventName, eventHandler) => {
  if (el.addEventListener) {
    el.addEventListener(eventName, eventHandler, false);
  } else {
    el.attachEvent('on'+eventName, eventHandler);
  }
};
// WordPress jQuery wrapper.
// Make sure any JavaScript that requires jQuery is wrapped in this pattern.
(($) => {
  $('document').ready(() => {
    // Turbolinks.start();
    // document ready action.
    XDCarousel.init();
    XDSlider.init();
    XDMediaGrid.init();
  
    // Add key bindings
    document.onkeydown = (e) => {
      if (e.target.tagName === 'BODY') {
        e = e || window.event;
        switch(e.code) {
          case "KeyS":
            UIkit.modal('#search_modal').show();
            setTimeout( () => {
              document.getElementById('search_modal_search_field').focus();
            }, 300);
            break;
        }
      }
    };
    
    // Focus on search field when opening modal nav.
    document.querySelectorAll('.xd-js__search-trigger').forEach((el) => {
      bindEvent(el, 'click', () => {
        setTimeout( () => {
          document.getElementById('search_modal_search_field').focus();
        }, 300);
      })
    });
    
    // prevent default by class name
    document.querySelectorAll('.js-prevent-default').forEach(el => {
      bindEvent(el, 'click', (e) => {
        e.preventDefault();
      });
    });
    
    // Navigation menu binding
    document.querySelectorAll('[data-menu-target]').forEach(el => {
      // Todo - set default height value on load for active menu.
      
      bindEvent(el, 'click', (e) => {
        e.preventDefault();
        
        const current_menu_id = el.parentNode.parentNode.dataset.menuId;
        const target_menu_id = el.dataset.menuTarget;
        
        const current_menu = document.querySelector(`[data-menu-id="${current_menu_id}"]`);
        const target_menu = document.querySelector(`[data-menu-id="${target_menu_id}"]`);
        
        if (current_menu.className.indexOf('active') >= 0 && current_menu.className.indexOf('inactive') < 0) {
          current_menu.className = current_menu.className.replace(/active/i,'inactive');  
        }

        if (target_menu.className.indexOf('inactive') >= 0) {
          target_menu.className = target_menu.className.replace(/inactive/i,'active');
        }
      });
    });

    
    /** --- NEWSLETTER ------------------------------------- */

    const newsletterNoCollapseFields = document.querySelectorAll('.xdf-newsletter__no-collapse');
    if (newsletterNoCollapseFields) {
      newsletterNoCollapseFields.forEach((el) => {
        bindEvent(el, 'click', () => {
          document.querySelectorAll('.xdf-newsletter--collapsed').forEach(el => {
            el.classList.add('xdf-newsletter--collapse');
            el.classList.remove('xdf-newsletter--collapsed');
          });
          
          const formElements = document.querySelectorAll('.xdf-newsletter li');
          formElements[1].children[1].children[0].focus();
        });
      });
    }

    const newsletterCloseButton = document.querySelector('.xdf-newsletter__close-button button');
    if (newsletterCloseButton) {
      bindEvent(newsletterCloseButton, 'click', (el) => {
        document.querySelectorAll('.xdf-newsletter--collapse').forEach(el => {
          el.classList.add('xdf-newsletter--collapsed');
          el.classList.remove('xdf-newsletter--collapse');
        });
      });
    }

    /** --- MODAL MENU  ---------------------------------------- */
    
    // Initialize Leap Menu options
    UIkit.util.on('#modal-menu', 'shown', () => { updateLeapMenu(); });

    // Resize Leap Menu container
    document.querySelectorAll('.xdf-modal-menu__body a').forEach((el) => {
      bindEvent(el, 'click', () => {
        if (el.getAttribute('data-menu-classes')) {
          const menuClasses = `xdf-leap-menu__container ${el.getAttribute('data-menu-classes')}`;
          document.querySelector('#xdf-leap-menu-container').className = menuClasses;
        } else {
          document.querySelector('#xdf-leap-menu-container').className = 'xdf-leap-menu__container';
        }

        updateLeapMenu();
      });
    });

    window.onresize(() => {
      if (document.querySelector('#modal-menu').classList.contains('uk-open')) {
        updateLeapMenu();
      }
    });    
		
		$('body').addClass('js-done wf-active ');
		
  });  // document ready
})(jQuery); // eslint-disable-line